export default __webpack_public_path__ + "static/media/loch-ness-jacobite.b3828079.webp";